


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted, useSlots, computed, watch, onBeforeUpdate, onUpdated } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import TabViewTypeConst from '../../../../domain/Constants/TabViewTypeConst';
import { Container } from 'inversify';
import { IServiceSearch } from '../../../../../search/application/IServiceSearch';
import { TYPES } from '../../../../../../../common/domain/types';
import HelperLoading from '../../../../../../../common/infrastructure/funciones/HelperLoading';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import CustomTabView from '../../../../../../../common/infrastructure/componentes/base/common/controles/CustomTabView.vue'
import ControlTypeConst from '../../../../domain/Constants/ControlTypeConst';
import TabPanel from 'primevue/tabpanel';

import multiTab from '../../../../domain/Functions/MultiTab';
import { useStore } from 'vuex';
import { Dictionary } from '../../../../../expression/domain/dictionary';
//import FormBuilder from '../../../FormBuilder2.vue';


export default defineComponent({
    name: 'dynamic_tab_view',
    components: {
        CustomTabView,
        //FormBuilder
    },
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },

    },
    setup(props, context) {
        //  
        const store = useStore();
        const { vmodel, loaded, resolveExpressions, getPropertyValue, getPropertyBooleanValue, getPropertyNumberValue, 
            setPropertyValueByName,baseOnMounted, baseOnUnmount, getLayoutComponent,fieldKey,fieldKeyComponentDataSourceId } = ComponentCommon(props, context,store);
      
        const { itemTabs,
            activeId,
            selectedTab,
            newKeys,
            changeTab,
            closeAllTabs,
            closeTab, redirectToActionPage,
            addTab,
            doActionTab,
        } = multiTab(store);

        let activeIndexBk = 0;
        const activeIndex = ref(0); // lo usamos solo para los tabviews
        watch(
            activeIndex, (newvalue, oldvalue) => {
          if (loaded.value && oldvalue !== newvalue) {
            setPropertyValueByName(TabViewTypeConst.ACTIVEINDEX,newvalue)
          }
        },
        {
          flush: 'post',
          //immediate: true, 
          deep: true
        }
      )
  
        onMounted(() => {
            activeIndex.value = getPropertyNumberValue(TabViewTypeConst.ACTIVEINDEX)
            activeIndexBk= activeIndex.value;
            baseOnMounted();

        })

        onUnmounted(() => {
            baseOnUnmount();
            setPropertyValueByName(TabViewTypeConst.ACTIVEINDEX,activeIndexBk)
        })

        onUpdated(() => {
            //addTab('uno',props.Component.applicationId,props.Component.applicationVersion,22019)
        })


        return {

            MessageService,
            MessageType,
            //showMessage,
            //clicktest,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            TabViewTypeConst,
            getPropertyNumberValue,
            loaded,
            BaseControlTypeConst,
            ControlTypeConst,
            getLayoutComponent,
            itemTabs,
            changeTab,
            fieldKey,
            fieldKeyComponentDataSourceId,
            activeIndex

        };
    },
});
